export default "__VITE_ASSET__Oz$arqBO__"